export const PLAN_NAME_CHARACTER_LIMIT = 255;
export const MIN_BILLING_RATE_CHANGE_PERCENT = -99;
export const MAX_BILLING_RATE_CHANGE_PERCENT = 200;
export const UPDATE_DEBOUNCE_TIME = 25;
